<template>
  <AdminModal
    :is-open="isOpen"
    modalSize="lg"
    :modal-title="`파일 링크 추가`"
    :close="close"
    confirm-button-title="업로드"
    :confirm="uploadFile"
    :loading="loading"
    name="uploadFileModal"
  >
    <b-container>
      <b-row>
        <b-form-group label="이름" label-cols-sm="3" label-size="sm">
          <b-form-input
            id="inline-form-input-name"
            class=" mr-sm-2 md-4"
            placeholder="이름을 입력해주세요."
            v-model="name"
          />
        </b-form-group>
      </b-row>
      <b-row>
        <b-form-group label="업로드 파일" label-cols-sm="3" label-size="sm">
          <input type="file" id="upload-image" @change="setFile($event.target.files)"/>
        </b-form-group>
      </b-row>
      <b-row class="my-2">
        <b-form-group label="파일경로" label-cols-sm="3" label-size="sm">
          <div class="flex inline-flex items-center w-full gap-2">
            <b-form-input
              id="inline-form-input-name"
              class=" mr-sm-2 md-4"
              placeholder="파일 경로를 입력하세요."
              v-model="filePath"
            />
            <span v-if="extension">{{extension}}</span>
          </div>
          <p class="text-rose-700 text-sm">파일 경로는 영어로 입력해주세요. (예 : mission1/book)</p>
        </b-form-group>
      </b-row>
      <b-row class="my-2">
        <b-form-group label="연결할 강의" label-cols-sm="3" label-size="sm">
          <b-form-select v-model="selected" :options="options"></b-form-select>
        </b-form-group>
      </b-row>
      <b-row class="my-2" v-if="!!selected">
        <b-form-group label="강의 교재 노출 여부" label-cols-sm="3" label-size="sm">
          <b-form-radio-group
            v-model="publishStatus"
            :options="publishOptions"
            class="mb-3"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
          />
        </b-form-group>
        <b-form-group label="클릭 시 팝업 내용" label-cols-sm="3" label-size="sm">
          <b-form-input
            id="inline-form-input-name"
            class=" mr-sm-2 md-4"
            placeholder="팝업 내용을 입력해주세요."
            v-model="popupContent"
          />
        </b-form-group>
        <b-form-group label="접속 코드 없이 교재 노출" label-cols-sm="3" label-size="sm">
          <b-form-checkbox
            id="inline-form-input-name"
            class=" mr-sm-2 md-4"
            v-model="passUnlock"
          />
        </b-form-group>
      </b-row>
      <b-row class="my-2">
        <b-form-group label="메모" label-cols-sm="3" label-size="sm">
          <b-form-textarea
            id="textarea"
            v-model="memo"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-form-group>
      </b-row>
    </b-container>
  </AdminModal>
</template>
<script>
import AdminModal from "@/components/modals/AdminModal.vue";
import customDate from "@/util/custom-date"
import api from "@/api/api"

export default {
  name: "UploadFileModal",
  components: {AdminModal},
  data() {
    return {
      name: "",
      file: null,
      filePath: '',
      extension: '',
      memo: "",
      popupContent: "",
      selected: null,
      publishStatus: "UNPUBLISHED",
      passUnlock: false,
      options: [{
        value: null,
        text: "없음"
      }],
      loading: false,
      publishOptions: [
        { item: "PUBLISHED", name: '노출' },
        { item: "UNPUBLISHED", name: '비노출' },
      ]
    }
  },
  props: ['isOpen', 'close', 'reload'],
  mounted() {
    this.getLessonContents()
  },
  methods: {
    getLessonContents() {
      api.lesson.lessonContents({},(response) => {
        this.options = this.options.concat(response.data.map((lessonContent) => ({
          value: lessonContent.id,
          text: `${lessonContent.lessonTitle}(${lessonContent.title})`
        })))
      }, (err) => {
        console.log(err)
      })
    },
    setFile(files) {
      const getFileNameAntExtension = (fileName) => {
        const lastIndexOfDot = fileName.lastIndexOf('.')
        return  {
          extension: fileName.substring(lastIndexOfDot, fileName.length),
          name: fileName.substring(0, lastIndexOfDot)
        }
      }

      this.file = files[0]
      const info = getFileNameAntExtension(this.file.name)
      this.filePath = info.name
      this.extension = info.extension
    },
    getDate(date) {
      return customDate.stringFormat(date)
    },
    uploadFile() {
      if (this.name.length === 0) {
        this.$toast.error('이름을 입력해주세요.',
          {
            position: "top-right",
            duration: 2000
          })
        return
      }

      if (!this.file){
        this.$toast.error('파일을 선택해주세요.',
          {
            position: "top-right",
            duration: 2000
          })
        return
      }

      const regex = /^[a-zA-Z0-9_\-/]+$/
      
      if (this.filePath.length > 0 && !regex.test(this.filePath)){
        this.$toast.error('파일 경로를 확인해주세요. 영어, 숫자, _, -, / 만 사용 가능합니다.',
          {
            position: "top-right",
            duration: 2000
          })
        return
      }
      
      this.loading = true
      let params = {
        name: this.name,
        file: this.file,
        filePath: this.filePath,
        memo: this.memo,
        status: this.publishStatus,
        popupContent : this.popupContent,
        passUnlock: this.passUnlock,
      }
      
      if (this.selected !== null) {
        params.lessonContentId = this.selected
      }

      api.file.uploadFile(params, (response) => {
        this.loading = false
        this.reload()
        this.close()
        console.log(response)
      }, (error) => {
        this.loading = false
        console.error(error)
        this.$toast.error(error.message,
          {
            position: "top-right",
            duration: 2000
          })
      })
    }
  }
}
</script>
<style scoped>

</style>